//Import Mixpanel SDK
import { TProfile } from "@shared/entities";
import mixpanel from "mixpanel-browser";
import { CONFIG } from "src/config";

// Near entry of your product, init Mixpanel
mixpanel.init("09fecdfa1b9848b51c4d3c69a119e2f9", {
	debug: CONFIG.IS_DEV,
	track_pageview: false,
	persistence: "localStorage",
});

type TRequestEvents =
	| "CLIENT_SELECT_REQUEST_PERSONAL_DETAILS"
	| "CLIENT_SELECT_REQUEST_MEDICAL_QUESTIONS"
	| "CLIENT_SELECT_REQUEST_DOSAGE"
	| "CLIENT_SELECT_REQUEST_DOCUMENTS";

type TEvent = "CLICK_ON_START" | "SIGNUP" | "LOGIN" | "PAGE_VIEW" | TRequestEvents;

export const analytics = {
	track(event: TEvent, payload?: any) {
		mixpanel.track(event, { ...payload, ...CONFIG });
	},
	identify(profile: TProfile) {
		mixpanel.identify(profile.id);
		mixpanel.people.set(profile);
	},
};
